import type React from 'react';

import { useSharingTools } from '../../hooks/useSharingTools';

import { RecommendedGroupsCardPreview } from './components/RecommendedGroupsCardPreview';

export const RecommendedGroupsCard: React.FC = () => {
	const { data, actions } = useSharingTools();

	return (
		<RecommendedGroupsCardPreview
			recommendedGroups={data.recommendedGroups}
			primaryAction={actions.navigateToGroupRecommendations}
			fallbackPrimaryAction={actions.navigateToEditPetition}
			onFacebookGroupClick={actions.openRecommendedFacebookGroupModal}
			onRedditGroupClick={actions.openRecommendedRedditGroupModal}
		/>
	);
};
